import {productoConstants} from '../_constants';
import {productoService} from '../_services';
import {store, TIPO_ENVIO, TIPO_REPUESTO} from '../_helpers';
import alertService from '../_services/cart/alert.service';
import productoServiceTs from '../_services/cart/producto.service';
import vendedorService from '../_services/cart/vendedor.service';

export const productoActions = {
    buscar,
    buscarBajaObjeto,
    grabar,
    normalizarParaGuardar,
    grabarRepuestosBaja,
    esComprable,
    esPrecioAConsultar,
    hayStock,
    enviarMensaje,
    crearLinkWhatsapp,
    actualizoCartService,
    crearNombreUnico,
    crearLinkWhatsappVenta,
    crearLinkWhatsappAUsuario,
    normalizarTelefono,
    tieneContactosExtra
};

export const randomNumberInRange = () => {
    let min = 0;
    let max = 1000;
    return Math.floor(Math.random()
        * (max - min + 1)) + min;
};


function buscarBajaObjeto(tipoRepuestos) {
    let bajaObjeto = tipoRepuestos.find(it => it.nombre == TIPO_REPUESTO.AUTO_DESARMADERO);
    return bajaObjeto;
}

function crearNombreUnico(producto) {
    let retValue = '';

    retValue = producto.tipoRepuesto.nombre + ' - ' + producto.marca.nombre + ' - ' + producto.modelo.nombre;

    return retValue;
}


function actualizoCartService() {
    function success(data) {
        return {type: productoConstants.REFRESH_CART, data: data}
    }

    store.dispatch(success({value: randomNumberInRange()}));
}

function enviarMensaje(producto) {
    return dispatch => {
    };
}


function crearLinkWhatsappVenta(venta, soyVendedorEnVenta) {
    let link = '';
    let telefono = soyVendedorEnVenta ? venta.comprador?.numeroCelular : venta.vendedor?.numeroCelular;

    if (telefono.startsWith('0')) {
        telefono = telefono.substring(1, telefono.length);
    }

    if (!telefono.startsWith('+549')) {
        telefono = '+549' + telefono;
    }

    let links = `https://deautopartes.ar/comprador/compraDetail?id=${venta.id}%20,%20`;

    // venta.items.forEach(item => {
    //     links = links + `https://deautopartes.ar/compraDetail?id=${item.producto.id}%20,%20`
    // });

    link = `https://api.whatsapp.com/send?phone=${telefono}&text=Me%20comunico%20por%20la%20venta%20${links}`;

    return link;
}

function crearLinkWhatsappAUsuario(usuario) {

    let telefono = usuario?.numeroCelular;

    if (telefono.startsWith('0')) {
        telefono = telefono.substring(1, telefono.length);
    }

    if (!telefono.startsWith('+549')) {
        telefono = '+549' + telefono;
    }

    let link = `https://api.whatsapp.com/send?phone=${telefono}&text=Hola%20Te%20escribo%20de%20sitio%20https://deautopartes.ar`;

    return link;
}

/**
 * Si el vendedor tiene otros WhatsApp cargados hay que ofrecer el modal para elegir; si no,
 * el boton "Consulta" va derecho al numero principal como toda la vida.
 *
 * Se responde con lo que hay en cache (lo llena `vendedorService.precargarContactos`) y no
 * con una consulta al vuelo: la decision se toma al renderizar el boton, porque un
 * `window.open` disparado despues de un fetch lo bloquea el navegador por popup.
 * Sin precarga devuelve false, o sea el comportamiento de antes.
 */
function tieneContactosExtra(producto) {

    const contactos = vendedorService.contactosEnCache(producto?.vendedor?.id);

    return !!contactos && contactos.length > 0;
}

/**
 * Deja el numero listo para un link de WhatsApp: saca el 0 inicial y le pone el +549 si
 * no lo trae. Es la misma regla que ya se usaba para el numero del vendedor, extraida
 * aca para que los contactos adicionales del modal de consulta la compartan.
 */
function normalizarTelefono(telefono) {

    if (!telefono) {
        return '';
    }

    let numero = String(telefono).trim();

    if (numero.startsWith('0')) {
        numero = numero.substring(1, numero.length);
    }

    if (!numero.startsWith('+549')) {
        numero = '+549' + numero;
    }

    return numero;
}

/**
 * `telefonoAlternativo` se usa cuando el comprador elige, en el modal de consulta, a uno
 * de los contactos que el vendedor cargo en su perfil en vez del numero principal.
 */
function crearLinkWhatsapp(producto, telefonoAlternativo) {

    let telefono = normalizarTelefono(telefonoAlternativo || producto.vendedor?.numeroCelular);

    let link = `https://api.whatsapp.com/send?phone=${telefono}&text=Necesito%20informacion%20del%20producto%20https://deautopartes.ar`+ productoServiceTs.crearUrlProducto(producto);

    return link;
}

/**
 * La publicacion se muestra sin precio y se arregla por consulta.
 *
 * <p>El backend deja el `precio` en null cuando el flag esta puesto, asi que quien no mire
 * esto pinta "$ 0" o "$ null" en vez del precio.
 */
function esPrecioAConsultar(producto) {
    return producto?.precioAConsultar === true;
}

/**
 * Si la publicacion se puede comprar por el sitio.
 *
 * <p>Gobierna a la vez el precio, el carrito y el badge de envio: son las tres cosas que
 * dejan de tener sentido cuando no hay una operacion de compra. Los autos de desarmadero
 * nunca se vendieron por aca (se compran los repuestos, no el auto), y ahora tampoco las
 * publicaciones a consultar — en esas el precio lo arreglan las dos partes por chat.
 */
function esComprable(producto) {
    return producto.tipoRepuesto.nombre !== TIPO_REPUESTO.AUTO_DESARMADERO
        && !esPrecioAConsultar(producto);

}

function hayStock(producto) {
    return (producto.cantidad != null && producto.cantidad > 0);

}


/** Numero o null: los inputs devuelven '' cuando el usuario los vacia. */
function aNumeroONull(valor) {
    if (valor === '' || valor === undefined || valor === null) return null;
    const num = Number(valor);
    return Number.isNaN(num) ? null : num;
}

/**
 * Arma el ProductoDto que espera el backend a partir de los valores del formulario.
 *
 * Hace falta porque el form arrastra campos que son solo de UI (`esBaja`, `crearStock`,
 * `nuevoMotorAsociado`) y strings vacios en campos numericos: eso es lo que hacia
 * fallar el parseo del JSON del lado del servidor.
 *
 * De las imagenes manda solo las nuevas: las que ya estan en S3 vuelven con id, y
 * las que se subieron recien en este mismo alta quedan marcadas con `guardada`.
 * Las que ya estan en S3 el backend las deja como estan, y asi el body no crece con
 * cada edicion — que era lo que hacia reventar la publicacion con fotos pesadas.
 */
function normalizarParaGuardar(values, {conservarVendedor = false} = {}) {
    const {
        esBaja, crearStock, nuevoMotorAsociado, misRepuestosBaja, vendedor, createdDate, active,
        ...resto
    } = values || {};

    const imagenes = (values?.imagenes || [])
        .filter((img) => !img.id && !img.guardada && !!img.base64)
        .map((img) => ({
            tipo: img.tipo,
            descripcion: img.descripcion,
            base64: img.base64,
            type: img.type
        }));

    return {
        ...resto,
        // Solo el back office manda vendedor: es a nombre de quien publica. En el carril
        // del vendedor el backend usa siempre el del token, asi que mandarlo no aporta.
        ...(conservarVendedor && vendedor?.id ? {vendedor: {id: vendedor.id}} : {}),
        id: aNumeroONull(values?.id),
        anio: aNumeroONull(values?.anio),
        kilometraje: aNumeroONull(values?.kilometraje),
        precioAConsultar: values?.precioAConsultar === true,
        // Con "a consultar" no se manda ni precio ni envio: el backend igual los fuerza, pero
        // asi el resumen del form y lo que viaja dicen lo mismo.
        precio: values?.precioAConsultar === true ? null : (aNumeroONull(values?.precio) ?? 0),
        tipoEnvio: values?.precioAConsultar === true ? TIPO_ENVIO.SIN_ENVIO : values?.tipoEnvio,
        cantidad: aNumeroONull(values?.cantidad) ?? 1,
        imagenes
    };
}


function grabar(values, handleSuccess, setGrabando) {
    setGrabando(true);
    return dispatch => {
        productoService.addEdit(normalizarParaGuardar(values))
            .then(
                data => {
                    alertService.msg('Producto actualizado exitosamente');
                    setGrabando(false);

                    const crearRepuestosBaja = values.esBaja && values.crearStock && values.id === '';

                    console.log(crearRepuestosBaja, values)
                    handleSuccess(crearRepuestosBaja, data.id);
                },
                error => {
                    alertService.error(error)
                    setGrabando(false);
                }
            );
    };
}


/** Con `vendedorId` va por el carril de admin, creando el stock a nombre de ese vendedor. */
function grabarRepuestosBaja(values, handleClose, setGrabando, vendedorId) {
    setGrabando(true);
    return dispatch => {
        (vendedorId
            ? productoService.grabarRepuestosBajaAdmin(values, vendedorId)
            : productoService.grabarRepuestosBaja(values))
            .then(
                data => {
                    alertService.msg('Productos añadidos exitosamente');
                    setGrabando(false);
                    handleClose();
                },
                error => {
                    alertService.error(error)
                    setGrabando(false);
                }
            );
    };
}


function buscar() {
    return dispatch => {
        productoService.buscar()
            .then(
                data => {
                    dispatch(success(data));
                },
                error => {
                    alertService.error(error)
                }
            );
    };

    function success(data) {
        return {type: productoConstants.GETALL_SUCCESS_CANDADO, candados: data}
    }
}
